import { Dispatch } from 'react';
import { GetBillingInfoAction, GET_BILLING_INFO } from '../types';
import { fetchBillingInfo } from '../../../../services/BillingInfoApi';
import { BillingInfo } from '../../../../models/BillingInfo';

const Log = console.log;

export const getBillingInfo = (): ((dispatch: Dispatch<GetBillingInfoAction>) => void) => {
    return async (dispatch: Dispatch<GetBillingInfoAction>) => {
        try {
            const billingInfo = await fetchBillingInfo();
            dispatch(receiverBillingInfo(billingInfo));
        } catch (error) {
            Log(error?.message);
        }
    };
};

const receiverBillingInfo = (billingInfo: BillingInfo): GetBillingInfoAction => {
    return {
        type: GET_BILLING_INFO,
        payload: { info: billingInfo },
    };
};
